export const MESSAGE_NOTIFICATION_EXPIRATION_TIME = 15 * 1000;
export const CUSTOMER_NAME_FALLBACK = "User";
